/**
 * The dialling facts about each country: which regions exist and what each one's
 * calling code is.
 *
 * Deliberately no names. Naming a country is a localisation concern and lives in
 * `@vav/i18n`, which owns the display data and the fallbacks; keeping it out of
 * here stops the protocol package from growing a dependency on locale data it
 * has no use for.
 */
import { getCountries, getCountryCallingCode, type CountryCode } from 'libphonenumber-js';

export interface CountryDialInfo {
  /** ISO 3166-1 alpha-2, the region libphonenumber parses against. */
  region: string;
  /** Calling code without the plus, e.g. `972`. */
  callingCode: string;
}

let cached: CountryDialInfo[] | undefined;

export function countryDialInfo(): CountryDialInfo[] {
  cached ??= getCountries().map((region) => ({
    region,
    callingCode: getCountryCallingCode(region as CountryCode),
  }));
  return cached;
}

export function dialInfoFor(region: string | undefined): CountryDialInfo | undefined {
  if (!region) return undefined;
  const wanted = region.toUpperCase();
  return countryDialInfo().find((entry) => entry.region === wanted);
}
